<template>
    <div><slot></slot></div>
</template>

<script>
  export default {
    name: 'SkillsSection',
    data() {
      // This solely exists to appear in the coverage report
      return {}
    }
  }
</script>
